import React, { useEffect, useReducer, useState } from 'react'
import Table from '../../../Setup/Shared/Table';
import Loader from '../../../shared/Loader/Loader';
import GridColumnHeader from "../../../Setup/Shared/GridColumnHeader"
import Modal from 'react-bootstrap/Modal';
import AddNewDocument from './AddNewDocument';
import { enumUtil } from '../../../../utils/Enum';
import { ServerRequestProtected, ServerRequestPublic } from '../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../utils/NotificationHandler';
import { connect, useDispatch, useSelector } from 'react-redux';
import isNull from '../../../../utils/NullChecking';
import { PWK } from '../../../../utils/Constants';
import DeleteConfirmatiom from '../../../General/DeleteConfirmation';
import FormValidator from '../../../../utils/FormValidator';
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { PracticeID } from '../../../../actions/LoginAction';
import { GeneralDropDowns } from '../../../../actions/GeneralPatientActions';
import ModalHeader from '../../../Setup/Shared/ModalHeader';
import { saveAs } from "file-saver"
import handleCopyText from '../../../shared/CopyData';
import { FindFirstChild } from '../../../../utils/FindMenuOption';
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList';
import DropdownValueHandler from '../../../shared/SuperSearch/DropdownValueHandler';
import ModalFooter from '../../../Setup/Shared/ModalFooter';
import MergeInsuranceForm from '../../../shared/MergeIntakeForms/MergeInsuranceForm';
import MergeDemographicsForm from '../../../shared/MergeIntakeForms/MergeDemographicsForm';
import { set } from 'lodash';
import IntakePreview from '../../../Scheduler/IntakePreview/IntakePreview';
import MergeROIForm from '../../../shared/MergeIntakeForms/MergeROIForm';
import MergeCreditCardForm from '../../../shared/MergeIntakeForms/MergeCreditCardForm';
import { IconDownload } from '../../../shared/IconsComponent/icons';
import IntakeEdit from '../../../Scheduler/Intake Edit/IntakeEdit';
const API_URL = enumUtil.controller.PATIENT
const API_URL_General = enumUtil.controller.General
const API_URL_Wasabi = enumUtil.controller.Wasabi
const Documents = (props) => {
  const { Settings } = { ...props }
  let IsEditAllowed = FindFirstChild('Patient', 'Document')?.IsAdd
  let IsDeleteAllowed = FindFirstChild('Patient', 'Document')?.IsDeleted
  let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
  PateintIDR = PateintIDR?.data?.id
  const [patientId, setPatientID] = useState(PateintIDR);
  const [modalActive, setModalActive] = useState(false)
  const [documentData, setDocumentData] = useState([])
  const [orignalDocument, setOrignalDocument] = useState([])
  const [documentTypeData, setDocumentTypeData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [searchParam, setSearchParam] = useState();
  const [isClose, setIsClose] = useState();
  const [PatientDocumentID, setPatientDocumentID] = useState('0')
  const [DocumentTypeID, setDocumentTypeID] = useState('0')
  const [DocumentTypeParentID, setDocumentTypeParentID] = useState('0')
  const [isOpenDocumentType, setIsOpenDocumentType] = useState(false)
  const [pdfFile, setPdfFile] = useState(null);
  const [txtFile, setTxtFile] = useState(null);
  const [imgFile, setImgFile] = useState(null);
  const [tiffFile, setTiffFile] = useState(null);
  const [isOpenAudit, setisOpenAudit] = useState(false);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const AddDocument = (ID, row) => {
    setPatientDocumentID(ID)
    handleOpenMergeForm(row)
  }
  const DownloadFile = (data) => {
    // let FileName;
    setIsLoading(true)
    ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
      // "ID": PateintIDR + "",
      "BucketPath": data.DocumentPath,
      // "Value":"270",
    }, "Download",).then((response) => {
      // ElectronicSubmissiomData.filter((item) => {
      //     if(item.EDIClaimBatchID === BatchID){
      //         FileName = item.FileName
      //     }
      // })
      setIsLoading(false)
      let blob = new Blob([response]);
      saveAs(blob, data.FileName);
    }).catch((error) => {
      setIsLoading(false)
      NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
    })
  }
  const [copiedText, setCopiedText] = useState({});

  const handleCopy = (row, type) => {
    let name = `${row}-${type}`;
    handleCopyText(type);
    setCopiedText({ ...copiedText, [name]: true });
    setTimeout(() => {
      setCopiedText({ ...copiedText, [name]: false });
    }, 300)
  }
  const DocumentType = {
    DocumentType: '',
    PWKDocumentType: '',
    DocumentDescription: '',
  }
  let valModal = {}
  let ValidationModal = {
    DocumentTypeVal: '',
  }
  const [isOpenAlert, setisOpenAlert] = useState(false);
  const [is, setIs] = useState(true);

  const [del, setDel] = useState(false)
  const [ParentID, setParentID] = useState(false)
  const [DocumetTypeValidationModal, setDocumetTypeValidationModal] = useState(ValidationModal)
  const [mainDocumentModal, setmainDocumentModal] = useState(DocumentType)
  const [DocumentSaveUpdateModal, setDocumentSaveUpdateModal] = useState({})
  const [FilterDocumentStatus, setFilterDocumentStatus] = useState('All')
  const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
    return { ...prev, ...next }
  }, { defaultData: '', activeSortIcon: '' })
  //For Pagination
  const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
  const [PageNo, setPageNo] = useState(1);
  const [TotalPages, setTotalPages] = useState();
  const handlePageClick = (page) => { setPageNo(page); }
  const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
  const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
  const handleFingByCreteria = (e) => {
    setPerPage(e.target.value)
    setPageNo(1)
  }
  const handleSelectData = (data) => {
    setPerPage(data.value)
    setPageNo(1)
  }
  const API_URL_General = enumUtil.controller.General
  const [isDocumetTypeSaved, setisDocumetTypeSaved] = useState()
  const [isCollapsed, setIsCollapsed] = useState(false);
  const dispatch = useDispatch();

  const [statusCount, setStatusCount] = useState({
    PendingSubmission: 0,
    ToReview: 0,
    TotalCount: 0,
  })
  /////////////////
  // Find by single Criteria Pateint Documents
  const LoadData = (param) => {
    setIsLoading(true)
    ServerRequestProtected(API_URL + "/FindBySingleCriteria", 'post', {
      "TableName": enumUtil.enumAPITableName.PatientDocument,
      "SearchParam": param,
      "PerPage": PerPage,
      "PageNo": PageNo,
      "ID": PateintIDR + ""
    }).then((response) => {
      setIsLoading(false)
      setDocumentData(response.Rows)
      setOrignalDocument(response.Rows)
      setStatusCount(response.count)
      handleGridHeader({ defaultData: response.Rows })
      setTotalPages(response.count.NumOfPages);
    }).catch((error) => {
      setDocumentData([])
      setOrignalDocument([])
      setIsLoading(false)
    })
  }
  const handleOpenEncounter = (row) => {
    if (isNull(row.EncounterID) || isNull(row.EncounterDate) || isNull(row.NoteType)) {
      console.error("Some necessary details to open encounter are missing");
      return;
    }
    let obj = {
      active: true,
      key: 2,
      name: "Encounter",
      data: {
        name: `${row.EncounterDate}`,
        id: row.EncounterID,
        type: row.NoteType,
        // patID: PatientIDR,
        time: new Date()
      },
    }
    // dispatch(TabActionEncounters(obj));      
    dispatch({
      type: 'Open_Encounter_Tab',
      payload: {
        patientId: PateintIDR,     // <-- needed to find the patient tab to update
        tab: obj            // the encounter tab object
      }
    });
  }
  let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
  // Merge Demographics Form
  const [isOpenDemoForm, setisOpenDemoForm] = useState(false)
  const [patientIntakeTemplateDataID, setPatientIntakeTemplateDataID] = useState(0)
  const handleOpenIntakeForm = (PatientIntakeTemplateDataID) => {
    setPatientIntakeTemplateDataID(PatientIntakeTemplateDataID)
    setisOpenDemoForm(true)
  }
  const handleCloseForm = () => {
    setisOpenDemoForm(false)
    setPatientIntakeTemplateDataID(0)
    LoadData()
  }
  let DemographicFormPopup
  if (isOpenDemoForm) {
    DemographicFormPopup = <MergeDemographicsForm mergeInfoForm={isOpenDemoForm} onClose={handleCloseForm} ID={patientIntakeTemplateDataID} />
  }
  // PAtient isnurance intake form
  const [IsOpenInsuranceForm, setIsOpenInsuranceForm] = useState(false)
  const handleOpenInsuranceForm = (PatientIntakeTemplateDataID) => {
    setIsOpenInsuranceForm(true)
    setPatientIntakeTemplateDataID(PatientIntakeTemplateDataID)
  }
  const handleCloseInsuranceForm = () => {
    setIsOpenInsuranceForm(false)
    setPatientIntakeTemplateDataID(0)
    LoadData()
  }
  let MergeInsurancePopup
  if (IsOpenInsuranceForm) {
    MergeInsurancePopup = <MergeInsuranceForm mergeInfoFormInsurance={IsOpenInsuranceForm} onClose={handleCloseInsuranceForm} ID={patientIntakeTemplateDataID} />
  }
  // Patient Release of information form
  const [IsOpenROIForm, setIsOpenROIForm] = useState(false)
  const handleOpenROIForm = (PatientIntakeTemplateDataID) => {
    setIsOpenROIForm(true)
    setPatientIntakeTemplateDataID(PatientIntakeTemplateDataID)
  }
  const handleCloseROIForm = () => {
    setIsOpenROIForm(false)
    setPatientIntakeTemplateDataID(0)
    LoadData()
  }
  let MergeROIPopup
  if (IsOpenROIForm) {
    MergeROIPopup = <MergeROIForm IsOpenROIForm={IsOpenROIForm} onClose={handleCloseROIForm} ID={patientIntakeTemplateDataID} PatientID={patientId} />
  }
  // Intake Form Preview
  const [isOpenCreditCardForm, setIsOpenCreditCardForm] = useState(false)
  const handleOpenCreditCardForm = (PatientIntakeTemplateDataID) => {
    setIsOpenCreditCardForm(true)
    setPatientIntakeTemplateDataID(PatientIntakeTemplateDataID)
  }
  const handleCloseCreditCardForm = () => {
    setIsOpenCreditCardForm(false)
    setPatientIntakeTemplateDataID(0)
    LoadData()
  }
  let MergeCreditCardPopup
  if (isOpenCreditCardForm) {
    MergeCreditCardPopup = <MergeCreditCardForm IsOpenCreditCardForm={isOpenCreditCardForm} onClose={handleCloseCreditCardForm} ID={patientIntakeTemplateDataID} />
  }

  const [EHRTemplateID, setEHRTemplateID] = useState(0);
  const [IsOpenIntakePreview, setIsOpenIntakePreview] = useState(false);
  const [IntakeFormID, setIntakeFormID] = useState(null);
  const [IntakeFormStatus, setIntakeFormStatus] = useState('');

  const handleIntakePreview = (templateID, intakeID, FormStatus) => {
    // console.log("handleIntakePreview", templateID, intakeID, FormStatus)
    setEHRTemplateID(templateID);
    setIntakeFormID(intakeID);
    // setPatientID(PatientID);
    setIntakeFormStatus(FormStatus);
    setIsOpenIntakePreview(true);
  }
  const onClose = () => {
    setIsOpenIntakePreview(false);
  }
  const onCloseSave = () => {
    setIsOpenIntakePreview(false);
    LoadData();
  }

  ////// Intake Form Status /////// 
  const handleIntakeStatus = (status, formID) => {
    let saveModal = {
      "TableName": enumUtil.enumAPITableName.PatientIntakeForm,
      "ID": formID,
      "Data": {
        "IntakeStatus": status
      }
    }
    setIsLoading(true);
    ServerRequestProtected(API_URL + '/ChangeIntakeFormStatus', 'post', saveModal)
      .then((response) => {
        setIsLoading(false);
        // setIntakeStatusValue(status);

        // setRejectedConfirmation(false);
        LoadData();
      }).catch((error) => {
        setIsLoading(false);
        NotificationHandler(error.message, enumUtil.enumtoaster.error);
      })
  }
  let IntakePreviewPopup = ""
  if (IsOpenIntakePreview) {
    IntakePreviewPopup = <IntakePreview isOpenPopup={IsOpenIntakePreview} onClose={onClose} onCloseSave={onCloseSave} ID={EHRTemplateID} intakeFormID={IntakeFormID} handleIntakeStatus={handleIntakeStatus} rejectionConfirmation={() => { }} PatientID={patientId} FormStatus={IntakeFormStatus} />
  }
  /////////////////////////// Intake Edit ////////////////////////
  let isEditAllowedFormAccess = FindFirstChild('Patient', 'Form Access')?.IsAdd;
  console.log("isEditAllowedFormAccess", FindFirstChild('Patient', 'Form Access'), isEditAllowedFormAccess)
  const [isOpenIntakeEdit, setIsOpenIntakeEdit] = useState(false)
  const [guidID, setGuidID] = useState(null)
  const onCloseEditIntake = () => {
    setIsOpenIntakeEdit(false);
    LoadData();
  }

  const onCloseEditSave = () => {
    setIsOpenIntakeEdit(false);
    LoadData();
  }

  const EditIntakeDocument = (id) => {
    if (isEditAllowedFormAccess) {
      setIsOpenIntakeEdit(true);
      setGuidID(id);
      // setIntakeFormID(item?.PatientInTakeFormID,);
    }
  }


  let IntakeEditPopup = ""
  if (isOpenIntakeEdit) {
    IntakePreviewPopup = <IntakeEdit isOpenPopup={isOpenIntakeEdit} onClose={onCloseEditIntake} onCloseSave={onCloseEditSave}
      ID={guidID}
    // intakeFormID={IntakeFormID} handleIntakeStatus={handleIntakeStatus} rejectionConfirmation={() => { }} PatientID={patientId} FormStatus={IntakeFormStatus} 
    />
  }
  //////////////////////////////////////////////////////////
  const isCustomForm = (val) => ['Custom Intake Form', 'Custom Consent Form'].includes(val);

  const handleOpenMergeForm = (item) => {
    if (item.Status === 'Submitted') {
      // if (item.FormDetailType === 'Custom Intake Form') {
      if (isCustomForm(item.FormDetailType)) {
        handleIntakePreview(item?.GuidID, item?.PatientInTakeFormID, item?.Status)
      } else {
        if (item.FileName === 'Patient Insurance.pdf') {
          handleOpenInsuranceForm(item.PatientInTakeFormID)
        } else if (item.FileName === 'Patient Demographics.pdf') {
          handleOpenIntakeForm(item.PatientInTakeFormID)
        } else if (item.FileName === 'Credit Card Authorization.pdf') {
          handleOpenCreditCardForm(item.PatientInTakeFormID)
        } else if (item.FileName === 'Release Of Information.pdf') {
          handleOpenROIForm(item.PatientInTakeFormID)
        }
      }
    } else {
      if (item.Status === 'Processed') {
      }
    }
  }
  const columns = [
    {
      key: 'FileName',
      name: (<GridColumnHeader gridHeader={"File Name"} handleGridHeader={() => { }}
        iconName={''} headerName={'Document Name'} sortIcon={true} type={'string'} colKey={'FileName'} data={documentData} setData={null} />),
      resizable: true,
      renderCell: ({ row }) => {
        return (<>
          {/* {(isNull(row.PatientDocumentID)) ?
          <>{row.FileName}</> : */}
          {['Awaiting Response', 'Processed', 'Deleted'].includes(row.Status) ?
            <>{row.FileName}</> :
            <button
              className="btn btn-link p-0" onClick={() => AddDocument(row.PatientDocumentID, row)}>
              {row.FileName}
            </button>}
          {/* } */}
        </>
        );
      },
    },
    {
      key: 'DocumentType',
      name: (<GridColumnHeader gridHeader={"Doc. Type"} handleGridHeader={() => { }}
        iconName={''} headerName={'Doc. Type'} sortIcon={true} type={'string'} colKey={'DocumentType'} data={documentData} setData={null} />),
      resizable: true,
    },
    // {
    //   key: 'Title',
    //   name: (<GridColumnHeader gridHeader={"Title"} handleGridHeader={() => { }}
    //     iconName={''} headerName={'Title'} sortIcon={true} type={'string'} colKey={'Title'} data={documentData} setData={null} />),
    //   resizable: true,
    // },
    {
      key: 'Description',
      name: (<GridColumnHeader gridHeader={"Description"} handleGridHeader={() => { }}
        iconName={''} headerName={'Description'} sortIcon={true} type={'string'} colKey={'Description'} data={documentData} setData={null} />),
      resizable: true,
      width: 200,
      renderCell: ({ row }) => {
        return (
          <>
            <div className="d-flex justify-content-between align-items-center w-100" >
              <div className='align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100'>
                <div className='copy_icon'>{row.Description}</div>
                <div className="icon_copy">
                  <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.PatientDocumentID, row.Description)}></i>
                  <p class="tool_tip xsm_text text-light">Copy</p>
                </div>
                {copiedText[`${row.PatientDocumentID}-${row.Description}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
              </div>
            </div>
          </>
        )
      }
    },
    {
      key: 'LinkedEncounter',
      // name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={() => { }}
      //   iconName={''} headerName={'Linked Encounter'} sortIcon={true} type={'string'} colKey={'LinkedEncounter'} data={documentData} setData={null} />),
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-Icon-awesome-user-tie'} headerName={'Linked Encounter'} sortIcon={true} type={'string'} colKey={'LinkedEncounter'} data={documentData} setData={setDocumentData} />),
      resizable: true,
      renderCell: ({ row }) => {
        return (
          <>{(row.LinkedEncounter === "Not Linked" || isNull(row.EncounterID) || isNull(row.EncounterDate) || isNull(row.NoteType)) ?
            <>{row.LinkedEncounter}</> :
            <button
              className="btn btn-link p-0" onClick={() => handleOpenEncounter(row)}>
              {row.LinkedEncounter}
            </button>
          }</>
        );
      },
    },
    {
      key: 'Status',
      // name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={() => { }}
      //   iconName={''} headerName={'Linked Encounter'} sortIcon={true} type={'string'} colKey={'LinkedEncounter'} data={documentData} setData={null} />),
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'icon-Icon-awesome-user-tie'} headerName={'Status'} sortIcon={true} type={'string'} colKey={'Status'} data={documentData} setData={setDocumentData} />),
      resizable: true,
      width: 160,
      renderCell: ({ row }) => {
        return (
          <>
            <div
              className={`pill cursor-pointer ${row.Status === 'Awaiting Response' ? 'Hold' : row.Status === 'Processed' ? 'Paid' : row.Status === 'Submitted' ? 'Submitted' : row.Status === 'Deleted' ? 'Denied-clr' : ''}`}
            // onClick={() => handleOpenMergeForm(row)}
            >
              {row.Status}
            </div>
          </>
        );
      },
    },
    {
      key: 'Action',
      name: (<GridColumnHeader iconName={''} headerName={'Action'} sortIcon={false} />),
      resizable: true,
      renderCell({ row }) {
        return (
          <div className='d-flex align-items-center gap-6 ar-action-data'>
            {/* <p className=''>Fill Form</p> */}
            {row.Status === 'Deleted' ? null :
              row.Status === 'Awaiting Response' ?
                <>
                  <p onClick={() => EditIntakeDocument(row.GuidID)} className={`text validate-color br-clr-light br-right-1 pe-1-5 text-nowrap cursor-pointer lh-18 user-select-none ${isEditAllowedFormAccess ? '' : 'disable'}`}>Fill Form</p>
                  <button className={IsDeleteAllowed ? 'border-0 bg-transparent p-0' : 'border-0 bg-transparent p-0 disabled'} onClick={() => DeleteIntakeDocument(row)}>
                    <i className="icon-delete text-danger fs-12"></i>
                  </button>
                </> :
                row.Status === 'Processed' || row.Status === 'Submitted' ?
                  <>
                    {(isCustomForm(row.FormDetailType) && row.Status === 'Submitted') ? <></> :
                      <>
                        <button className='border-0 no-width Sdownload-btn' onClick={() => DownloadFile(row)}>
                          <i className="icon-download-svgrepo-com" />
                        </button>
                        <i class="icon-Icon-awesome-eye fs-12" onClick={() => ViewPdf(row)}></i>
                      </>}
                    {/* <button className={IsDeleteAllowed ? 'border-0 bg-transparent p-0' : 'border-0 bg-transparent p-0 disabled'} onClick={() => DeleteDocument(row)}>
                    <i className="icon-delete text-danger fs-12"></i>
                  </button> */}
                  </> :
                  <>
                    <button className='border-0 no-width ms-2 Sdownload-btn' onClick={() => DownloadFile(row)}>
                      <i className="icon-download-svgrepo-com" />
                    </button>

                    <i class="icon-Icon-awesome-eye fs-12" onClick={() => ViewPdf(row)}></i>

                    <button className={IsDeleteAllowed ? 'border-0 bg-transparent p-0' : 'border-0 bg-transparent p-0 disabled'} onClick={() => DeleteDocument(row)}>
                      <i className="icon-delete text-danger fs-12"></i>
                    </button>
                  </>
            }
          </div>
        )
      }
    }
  ];
  // Find by single Criteria Document Type
  useEffect(() => {
    LoadData();
    setIsLoading(true)
  }, [PerPage, PageNo, isClose])
  const LoadGridDataDD = () => {
    ServerRequestProtected(API_URL + "/FindBySingleCriteria", 'post', {
      "TableName": enumUtil.enumAPITableName.DocumentType,
    }).then((response) => {
      setIsLoading(false)
      setDocumentTypeData(response.Rows)
    }).catch((error) => {
      setIsLoading(false)
    })
    ServerRequestProtected(API_URL_General + "/FillDropdowns", 'post', {
    }).then((response) => {
      dispatch(GeneralDropDowns({ ...DropDowns, DocumentType: response.DocumentType }))
      dispatch(PracticeID(response.Practice[0]?.PracticeID))
    }).catch((error) => {
      NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
    })
  }
  useEffect(() => {
    LoadGridDataDD()
  }, [isDocumetTypeSaved])
  useEffect(() => {
    if (!isNull(props.Reload)) {
      let data = props.id
      data.map((item) => {
        if (item.key === 214) {
          LoadData()
          LoadGridDataDD()
        }
      })
    }
  }, [props.Reload])
  const [pictureData, setPictureData] = useState([])
  const ViewPdf = (data) => {
    setPdfFile(null)
    setTxtFile(null)
    setImgFile(null)
    setIsLoading(true)
    ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
      "BucketPath": data.DocumentPath
    }, 'Download').then((response) => {
      setIsLoading(false)
      if (response.type === 'application/txt') {
        const blob = response;
        const reader = new FileReader();
        reader.onload = () => {
          const content = reader.result;
          setTxtFile(content);
        };

        reader.readAsText(blob, 'utf-8');
      } else if (response.type === 'application/png') {
        const blob = response
        const objectURL = URL.createObjectURL(blob);
        setImgFile(objectURL)
      } else if (response.type === 'application/tiff') {

      }
      else {
        let file = new Blob([response]);
        const fileUrl = URL.createObjectURL(file);
        setPdfFile(fileUrl)
      }
      setPictureData(data)
      setModalActive(true)
    }).catch((error) => {
      setIsLoading(false)
      NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
    })
  }
  const DeleteDocument = (data) => {
    if (IsDeleteAllowed) {
      setIsLoading(true)
      ServerRequestProtected(API_URL + "/DeletePatientDocument", 'post', {
        "FilePath": data.DocumentPath,
        "ID": data.ID,
        "TableName": enumUtil.enumAPITableName.PatientDocument,
      }).then((response) => {
        setIsLoading(false)
        NotificationHandler('Deleted Succesfully', enumUtil.enumtoaster.success);
        setIsClose((Math.random()))
      }).catch((error) => {
        setIsLoading(false)
        NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
      })
    }
  }
  const DeleteIntakeDocument = (data) => {
    if (IsDeleteAllowed) {
      setIsLoading(true)
      ServerRequestProtected(API_URL_General + "/DeleteSingleRecord", 'post', {
        "ID": data.ID,
        "TableName": enumUtil.enumAPITableName.PatientIntakeForm,
      }).then((response) => {
        setIsLoading(false)
        NotificationHandler('Deleted Succesfully', enumUtil.enumtoaster.success);
        setIsClose((Math.random()))
      }).catch((error) => {
        setIsLoading(false)
        NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
      })
    }
  }
  //handle Change Document Type
  const handleDocumentTypeChange = (e) => {
    setIs(false)
    let { name, value } = e.target;
    if (process.env.REACT_APP_ISUPPERCASE === "true") {
      value = value.toUpperCase()
    }
    let modal = { ...mainDocumentModal };
    let saveModal = { ...DocumentSaveUpdateModal }
    modal[name] = value
    setmainDocumentModal(modal)
    for (var property in DocumentType) {
      if (name === property) {
        saveModal[name] = value
      }
    }
    setDocumentSaveUpdateModal(saveModal)
  }
  const handleSelectedData = (selectedData, name, type) => {
    setIs(true)
    let modal = { ...mainDocumentModal };
    if (type === 'client' && !isNull(selectedData)) {
      if (name === 'FilterDocumentStatus') {
        if (selectedData.value === 'All') {
          setDocumentData(orignalDocument)
          setFilterDocumentStatus('All')
          return selectedData
        }
        let data = orignalDocument.filter((item) => {
          return item.Status === selectedData.value
        })
        setDocumentData(data)
        setFilterDocumentStatus(selectedData.value)
      } else {
        modal[name] = selectedData.display
        DocumentSaveUpdateModal[name] = selectedData.value;
      }
    }
    else {
      modal[name] = ''
      DocumentSaveUpdateModal[name] = ''
    }
    setmainDocumentModal(modal)
    return selectedData
  }
  const DocuumentTypeValidation = async () => {
    let ValidationModal = {
      DocumentTypeVal: FormValidator(
        mainDocumentModal.DocumentType,
        enumUtil.enumValidationType.Required,
        'Document Type',
      ),
    }
    await setDocumetTypeValidationModal(ValidationModal)
    valModal = ValidationModal
  }
  //handle Save Document Type
  const handleSaveDocumentType = async () => {
    await DocuumentTypeValidation()
    let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
    if (validation) {
      NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
      return
    } else {
      if (DocumentTypeParentID != '0') {
        DocumentSaveUpdateModal['DocumentTypeID'] = DocumentTypeParentID
      }
      let saveModal = {
        TableName: enumUtil.enumAPITableName.DocumentType,
        ID: DocumentTypeID,
        data: { ...DocumentSaveUpdateModal },
      }
      setIsLoading(true)
      ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
        .then((response) => {
          if (!isNull(response.id)) {
            setIsLoading(false)
            NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
            setDocumentTypeID(response.id)
            setDocumentTypeParentID('0')
          }
        }).catch((error) => {
          setIsLoading(false)
          NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
          console.log('error', error);
        })
    }
  }
  const handleCancel = () => {
    setPatientDocumentID('0')
  }
  const handleOpenDocumentType = (node) => {
    setIsLoading(true)
    setDocumentTypeParentID(node.DocumentTypeID)
    setmainDocumentModal(DocumentType)
    setIsOpenDocumentType(true)
    setIsLoading(false)
    setDocumentTypeID('0')
  }
  let DeleteConfirmation = "";
  const handleDeleteModal = () => {
    setDel(true)
    setisOpenAlert(true)
  }
  const onCloseDelete = () => {
    setisDocumetTypeSaved((Math.random()))
    setisOpenAlert(false)
  }
  let DeletePopup = "";
  if (del) {
    DeletePopup = <button className={IsDeleteAllowed ? 'btn-icon-transparent ' : 'btn-icon-transparent delete-btn-disabled'} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
  }
  if (isOpenAlert) {
    DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.DocumentType} ID={DocumentTypeID} onClose={onCloseDelete} />
  }
  const handleCloseDocumentType = () => {
    setIsOpenDocumentType(false)
    setisDocumetTypeSaved((Math.random()))
  }
  const DocumentList = ({ data }) => {
    const [expandedItems, setExpandedItems] = useState([]);
    const toggleExpand = (parentId) => {
      if (expandedItems.includes(parentId)) {
        setExpandedItems(expandedItems.filter((item) => item !== parentId));
      } else {
        setExpandedItems([...expandedItems, parentId]);
      }
    };
    const getChildren = (parentId) => {
      return data.filter((item) => item.ParentID === parentId);
    };
    const renderChildren = (parentId) => {
      const children = getChildren(parentId);
      if (children.length === 0) {
        return null;
      }
      return (
        <div className='d-flex flex-column gap-1 mb-1'>
          {children.map((child) => (
            <>
              <div className='hk-treeView' key={child.RecordID} style={{ marginLeft: '20px' }}>
                <div className='hk-treeView__head'>
                  <div className='hk-treeView__head__title'>
                    {getChildren(child.DocumentTypeID).length > 0 && (
                      <span onClick={() => toggleExpand(child.DocumentTypeID)}>
                        {expandedItems.includes(child.DocumentTypeID) ? <i className='icon-down-direction'></i> : <i className='icon-right-direction'></i>}
                      </span>
                    )}
                    <span className='hk-treeView__head__title__name ms-0'>
                      <i className="icon-Icon-ionic-md-document"></i>
                      {child.DocumentType}
                    </span>
                  </div>
                  <div className='hk-treeView__head__btns d-flex align-items-center gap-1'>
                    <div className='d-flex' onClick={() => handleOpenDocumentType(child)}>
                      <span className="icon" >
                        <i className="icon-plus-icon"></i>
                      </span>
                    </div>
                    <div className='d-flex' onClick={() => handleEdit(child)}>
                      <i className='icon-edit-pencil fs-13'></i>
                    </div>
                    <div className={IsDeleteAllowed ? 'd-flex' : 'd-flex disabled'} onClick={() => handleDelete(child)}>
                      <i className='icon-delete text-danger fs-13'></i>
                    </div>
                  </div>
                </div>
                {expandedItems.includes(child.DocumentTypeID) && renderChildren(child.DocumentTypeID)}
              </div>
            </>
          ))}
        </div>
      );
    };
    const handleEdit = (node) => {
      setIsLoading(true)
      ServerRequestProtected(API_URL + "/FindByID", 'post', {
        "TableName": enumUtil.enumAPITableName.DocumentType,
        "ID": node.DocumentTypeID + ""
      }).then((response) => {
        setIsOpenDocumentType(true)
        response.PWKDocumentType = DropdownValueHandler(PWK, response.PWKDocumentType)
        setmainDocumentModal(response)
        setDocumentTypeID(response.DocumentTypeID + "")
        setIsLoading(false)
      }).catch((error) => {
        setIsLoading(false)
        NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
      })
    }
    const handleDelete = (node) => {
      setDocumentTypeID(node.DocumentTypeID)
      setisOpenAlert(true)
    }
    return (
      <div className='d-flex flex-column gap-6'>
        {data
          .filter((item) => item.ParentID === "")
          .map((parent) => (
            <>
              <div className='hk-treeView' key={parent.RecordID}>
                <div className='hk-treeView__head'>
                  <div className='hk-treeView__head__title'>
                    {getChildren(parent.DocumentTypeID).length > 0 && (
                      <span onClick={() => toggleExpand(parent.DocumentTypeID)}>
                        {expandedItems.includes(parent.DocumentTypeID) ? <i className='icon-down-direction'></i> : <i className='icon-right-direction'></i>}
                      </span>
                    )}
                    <span className='hk-treeView__head__title__name'>
                      <i className="icon-Icon-ionic-md-document" onClick={() => handleEdit(parent)}></i>
                      {parent.DocumentType}
                    </span>
                  </div>

                  <div className='hk-treeView__head__btns d-flex align-items-center gap-1'>
                    <div className="d-flex" onClick={() => handleOpenDocumentType(parent)}>
                      <span className="icon" >
                        <i className="icon-plus-icon"></i>
                      </span>
                    </div>
                    <div className={IsEditAllowed ? "d-flex" : "disabled d-flex"} onClick={() => handleEdit(parent)}>
                      <i className='icon-edit-pencil fs-13'></i>
                    </div>
                    <div className={IsDeleteAllowed ? "d-flex" : "disabled d-flex"} onClick={() => handleDelete(parent)}>
                      <i className='icon-delete text-danger fs-13'></i>
                    </div>
                  </div>
                </div>
                {expandedItems.includes(parent.DocumentTypeID) && renderChildren(parent.DocumentTypeID)}
              </div>
            </>
          ))}
      </div>
    );
  };
  const handleAuditModal = () => {
    setisOpenAudit(true)
  }
  const SetPOSName = () => {
    if (mainDocumentModal.DocumentType != null && mainDocumentModal.DocumentType != "") {
      return (
        <p className="heading">{mainDocumentModal.DocumentType}</p>
      )
    } else {
      return (
        <p className="heading">Add New Document Type</p>
      )
    }
  }

  const handleCollapseClick = () => {
    setIsCollapsed(!isCollapsed); // Toggle the collapse state
  };

  return (
    <div className={`hk-docFlex row ar_new-document-design m-0 g-0 ${isCollapsed ? "doc-type-colasped" : ""}`}>
      {isLoading ? <Loader /> : null}
      {DeleteConfirmation}
      {DemographicFormPopup}
      {MergeInsurancePopup}
      {IntakeEditPopup}
      {IntakePreviewPopup}
      {MergeROIPopup}
      {MergeCreditCardPopup}
      <div className="hk-docFlex__sidebar col-md-3 pe-0">
        <div className="hk-docFlex__sidebar__header px-2 mb-12 pt-2">
          <button className="btn btn-theme px-10 d-flex align-items-center gap-1" onClick={handleOpenDocumentType}>Document Types
            <span className="icon d-flex align-items-center justify-content-center">
              <i className="icon-plus-icon"></i>
            </span>
          </button>
        </div>

        <div className="hk-docFlex__sidebar__content">
          <DocumentList data={documentTypeData ? documentTypeData : []} />
        </div>
      </div >
      <div className="hk-docFlex__content col-md-9 pe-0 position-relative">

        <div className="collaspe-sidebar d-flex justify-content-center align-items-center position-absolute" onClick={handleCollapseClick}>
          <i className="icon-angle-left  fs-11"></i>
        </div>

        <div className="row hk-docFlex__content__flex m-0 g-0">
          <div className="doc-table col-md-8 px-0 doc_list ar-no-doc">
            <div className="doc-table__header">
              {/* <p className="heading fs-16">Document Lists</p> */}
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-6">
                  <p className="text br-right-1 br-clr-light pe-1-5">Total Documents: <span className="font-m">{statusCount.TotalCount ? statusCount.TotalCount : 'N/A'}</span></p>

                  <div className='d-flex align-items-center gap-1 Hold ar-status-clm fst-normal px-1-5'>
                    <i className='bi bi-info-circle-fill fs-11 Hold-clr'></i>
                    <p className="text">Pending Submission: <span className="font-m">{statusCount.PendingSubmission ? statusCount.PendingSubmission : 'N/A'}</span></p>
                  </div>

                  <div className='d-flex align-items-center gap-1 In-Review ar-status-clm fst-normal px-1-5'>
                    <i className='bi bi-info-circle-fill fs-11'></i>
                    <p className="text">To Review: <span className="font-m">{statusCount.ToReview ? statusCount.ToReview : 'N/A'}</span></p>
                  </div>
                </div>

                <div className="input">
                  <SuperSearchList
                    type="client"
                    id='FilterDocumentStatus'
                    name='FilterDocumentStatus'
                    searchValue={FilterDocumentStatus}
                    data={[
                      { value: 'All', display: 'All' },
                      { value: 'Submitted', display: 'Submitted' },
                      { value: 'Processed', display: 'Processed' },
                      { value: 'Awaiting Response', display: 'Awaiting Response' },
                      { value: 'Deleted', display: 'Deleted' },
                    ]}
                    onChange={(e) => { setIs(false); setFilterDocumentStatus(e.target.value) }}
                    getSelectedData={handleSelectedData}
                    is={is}
                    sup_btn='sup_btn-Inp'
                    sup_inp='superSearchVisitInp'
                  // disableInput={true}
                  />

                </div>
              </div>
            </div>

            <div className="position-relative">
              <Table
                columns={columns}
                rows={documentData}
                height='465px'
                dynamicClass='fill-grid DataGrid-Table hk-exp-table patient_doc '
                rowHeight={25}
                PerPage={PerPage}
                PageNo={PageNo}
                TotalPages={TotalPages}
                handlePageClick={handlePageClick}
                PreviousPage={PreviousPage}
                handleFingByCreteria={handleFingByCreteria}
                NextPage={NextPage}
                // hidePagination={true}
                Key={21}
                Name={'PatientSearch'}
                hideColClass={'hide'}
                handleSelectData={handleSelectData}
              />
            </div>

          </div>
          <div className="doc-right-col col-md-4 ps-0">
            <div className="upload-box">
              <div className="upload-box__header">
                <p className="heading">Upload Document</p>
                <span className="icon-box">
                  <i className="icon-upload-converted"></i>
                </span>
              </div>
              <AddNewDocument PatientDocumentID={PatientDocumentID} onCancel={handleCancel} setIsClose={setIsClose} ActivePatientID={props.ActivePatientID} />
            </div>
          </div>
        </div>

      </div>
      {/* Document Type Save and Update Modal */}
      <Modal show={isOpenDocumentType} onHide={() => setIsOpenDocumentType(false)} backdrop="static" keyboard={false} centered dialogClassName="app-modal add_doc_types hk-modal-v1">
        <Modal.Body>
          {isLoading ? <Loader /> : null}
          <ModalHeader HeaderName={SetPOSName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={handleCloseDocumentType} key={612} Name={'Documents'} />
          <div className={DocumetTypeValidationModal.DocumentTypeVal ? 'form-group input error' : 'form-group input'}>
            <label htmlFor="DocumentType mb-2">Document Type<span className='req'>*</span></label>
            <input
              type="text"
              className="form-control"
              id="DocumentType"
              name="DocumentType"
              value={mainDocumentModal.DocumentType}
              onChange={handleDocumentTypeChange}
            />
            {DocumetTypeValidationModal.DocumentTypeVal}
          </div>
          <div className="form-group input">
            <label htmlFor="DocumentDescription">Document Description</label>
            <textarea
              type="text"
              className="form-control"
              id="DocumentDescription"
              name="DocumentDescription"
              value={mainDocumentModal.DocumentDescription}
              onChange={handleDocumentTypeChange}
              rows="3"
            />
          </div>
          <div className="form-group input">
            <label htmlFor="PWKDocumentType" className="mb-2">PWK Document Type</label>
            <SuperSearchList
              type="client"
              id='PWKDocumentType'
              name='PWKDocumentType'
              searchValue={mainDocumentModal.PWKDocumentType}
              data={PWK}
              onChange={handleDocumentTypeChange}
              getSelectedData={handleSelectedData}
              is={is}
              sup_btn='sup_btn-Inp'
              sup_inp='superSearchVisitInp'
            />
          </div>
        </Modal.Body>
        <ModalFooter isSaved={handleCloseDocumentType} handleSave={handleSaveDocumentType} key={214} Name={'PatDocuments'} UpdatedDate={mainDocumentModal.UpdatedDate} UpdatedBy={mainDocumentModal.UpdatedBy} ID={DocumentTypeID} IsEditAllowed={IsEditAllowed} />
      </Modal>
      <Modal show={modalActive} onHide={() => setModalActive(false)} backdrop="static" keyboard={false} centered dialogClassName={`app-modal modal-md hk-login-v1 hk-modal-v1 ${!isNull(imgFile) ? 'ar_image_modal-new-changes ' : null}`}>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-between gap-20 mb-12">
            <p className="heading fs-14 dark-clr validation_message text-nowrap">{pictureData?.FileName || 'N/A'}</p>
            <div className="d-flex align-items-center gap-1">
              <span onClick={() => DownloadFile(pictureData)} className='d-flex' >
                <IconDownload />
              </span>
              {/* <IconDownload /> */}
              <i className="icon-x-cros fs-18 dark-clr" onClick={() => setModalActive(false)}></i>
            </div>
          </div>

          <div className="image-box">
            {!isNull(txtFile) ? txtFile : ''}
            {!isNull(imgFile) ? <img src={imgFile} alt='Image' /> : ''}

          </div>
          {isLoading ? <Loader /> : null}

          {pdfFile &&
            <>
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                <Viewer fileUrl={pdfFile}
                  defaultScale={1}
                  plugins={[defaultLayoutPluginInstance]} />
              </Worker>
            </>
          }
        </Modal.Body>
      </Modal>

    </div>
  )
}
const mapStateToProps = (state) => {
  return {
    Settings: state.SettingsReducer
  }
}
export default connect(mapStateToProps)(Documents)